import { render, staticRenderFns } from "./EventsSensitivitiesCard.vue?vue&type=template&id=071fe830&"
import script from "./EventsSensitivitiesCard.vue?vue&type=script&lang=ts&"
export * from "./EventsSensitivitiesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports